import React, { Component } from "react";
import firebase from "../../redux/store";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
    };
  }

  logout() {
    console.log("logout");
    firebase
      .auth()
      .signOut()
      .then(() => {})
      .catch((error) => console.log(error));
  }

  render() {
    return (
      <div
        id="menu"
        className="menu menu-box-left"
        data-menu-effect="menu-over"
        data-menu-select="page-home"
      >
        <a href="#" className="nav-title color-theme">
          Maprint
        </a>
        <div className="nav nav-medium">
          <div className="divider"></div>
          <a href="#" onClick={() => this.state.app.change("wallet")}>
            <i className="fad fa-wallet"></i>
            <span>Wallet</span>
          </a>
          {/* <a href="#" onClick={() => this.state.app.change("account")}>
            <i className="fad fa-user-alt"></i>
            <span>Account details</span>
          </a> */}
          <a href="#" onClick={this.logout.bind(this)}>
            <i className="fad fa-sign-out-alt"></i>
            <span>Log out</span>
          </a>
          <div className="divider mt-3"></div>
          <span style={{ 
            display: 'block', 
            marginLeft: '15px', 
            color: '#999', 
            fontSize: '12px',
            marginTop: '10px' 
          }}>v1.3.23</span>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menus/menu.js